exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mark-hover:hover{background-color:#8df}.first-row{margin-top:2rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/app/authentication/component/dummy/dummyAuthentication.scss
// module id = LP7T
// module chunks = 0